/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class VisIndicatorsProviderAPI
 * @hideconstructor
 * @classdesc API class that is used to implement a visIndicator provider for the purpose of contributing a visIndicator
 */
define([], () => {
	class VisIndicatorsProviderAPI {

		/**
		 * @function VisIndicatorsProviderAPI#getIndicatorList
		 * @description Returns a list of indicators available
		 * @return {array} array containing all available indicators
		 */
		getIndicatorList() {}

	}

	return VisIndicatorsProviderAPI;
});